import { Injectable } from '@angular/core';
import {ApplicationStatus} from '../enums/application/ApplicationStatus';
import {FacilityStatuses} from '../enums/facility/FacilityStatuses.enum';
import {SurveyStatus} from '../enums/survey/SurveyStatus';
import {SurveyDecision} from '../enums/survey/SurveyDecision';
import {SurveyType} from '../enums/survey/SurveyType';

@Injectable({
  providedIn: 'root'
})
export class EnumKeyService {

  constructor() { }

   appStatus = new Map(
    Object.entries(ApplicationStatus)
      .map(entry => entry.reverse()) as [ApplicationStatus, keyof typeof ApplicationStatus][]
  );

  facilityStatus = new Map(
    Object.entries(FacilityStatuses)
      .map(entry => entry.reverse()) as [FacilityStatuses, keyof typeof FacilityStatuses][]
  );

  surveyStatus = new Map(
    Object.entries(SurveyStatus)
      .map(entry => entry.reverse()) as [SurveyStatus, keyof typeof SurveyStatus][]
  );

  surveyType = new Map(
    Object.entries(SurveyType)
      .map(entry => entry.reverse()) as [SurveyType, keyof typeof SurveyType][]
  );

  surveyDecision = new Map(
    Object.entries(SurveyDecision)
      .map(entry => entry.reverse()) as [SurveyDecision, keyof typeof SurveyDecision][]
  );
}
